import { Configuration, ExceptionlessClient } from "@exceptionless/react";
import { fireAndForget } from "../async/fireAndForget";
import type { FrontendExceptionlessInfoModel } from "../../../OpenApi/api";

export class ExceptionlessClientFactory {
	/**
	 * Creates an instance of ExceptionlessClient and starts it through a fire and forget operation.
	 * ⚠️ It can happen that the client is not yet started when the method returns!
	 * @param loggerSettings
	 * @param tags
	 */
	public static create(loggerSettings: FrontendExceptionlessInfoModel, tags: string[]): ExceptionlessClient | null {
		const config = ExceptionlessClientFactory.getConfiguration(loggerSettings, tags);
		if (!config) {
			return null;
		}
		const client = new ExceptionlessClient(config);
		fireAndForget(client.startup());
		return client;
	}

	/**
	 * Creates an instance of ExceptionlessClient and starts it through a fire and forget operation.
	 * @param loggerSettings
	 * @param tags
	 */
	public static async createAsync(loggerSettings: FrontendExceptionlessInfoModel, tags: string[]): Promise<ExceptionlessClient | null> {
		const config = ExceptionlessClientFactory.getConfiguration(loggerSettings, tags);
		if (!config) {
			return null;
		}
		const client = new ExceptionlessClient(config);
		await client.startup();
		return client;
	}

	private static getConfiguration(loggerSettings: FrontendExceptionlessInfoModel, tags: string[]): Configuration | null {
		const config = new Configuration();

		const { url, apiKey } = loggerSettings;

		if (!url || !apiKey) {
			return null;
		}

		config.apiKey = apiKey;
		config.serverUrl = url;
		config.updateSettingsWhenIdleInterval = 0;
		config.defaultTags.push(...tags);
		config.includeIpAddress = false;
		config.includeCookies = false;
		config.includeUserName = false;
		config.includeMachineName = false;

		return config;
	}
}
